import { useBlocker } from 'react-router-dom';
import React, { useCallback, useEffect, useState } from 'react';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogTitle,
} from 'src/components/ui/dialog';
import { Button } from 'src/components/ui/button';
import { ToolTip } from 'src/components/ToolTip/ToolTip';
import { useLoader } from 'src/provider/LoaderProvider';

export const NotDeployedSettingsPopup = ({ activeSettings, onDeployClick = () => {} }) => {
  const [open, setOpen] = useState(false);
  const loader = useLoader();
  const blocker = useBlocker(
    useCallback(
      ({ currentLocation, nextLocation }) => {
        const isDifferent = currentLocation.pathname !== nextLocation.pathname;
        const isConfiguration = currentLocation.pathname.includes('/configuration');
        const isDeployed = activeSettings?.is_deployed;

        return isConfiguration && !isDeployed && isDifferent;
      },
      [activeSettings],
    ),
  );

  useEffect(() => {
    if (blocker.state === 'blocked') {
      onOpenChange(true);
    }
  }, [blocker]);

  const onOpenChange = (isOpen) => {
    setOpen(isOpen);
  };

  const onSaveForLater = () => {
    blocker.proceed();
    onOpenChange(false);
  };

  const onDeploy = async () => {
    await onDeployClick();
    loader.hide();
    blocker.proceed();
    onOpenChange(false);
  };

  return (
    <Dialog onOpenChange={onOpenChange} open={open}>
      <DialogContent
        onOpenAutoFocus={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
        closeButtonHidden
        className={'py-7.5 !max-w-[525px] gap-3.5 bg-light'}
      >
        <DialogTitle>
          <p className={'text-center text-lg text-ebony font-semibold'}>
            You haven’t deployed the updated AI agent
          </p>
        </DialogTitle>
        <div className="sub-title flex flex-col items-center gap-3.5 w-full justify-center">
          <p className={'text-center text-sm text-ebony_opacity_80 font-medium'}>
            You’ve configured a new version for your AI agent, but it <br />
            hasn’t been deployed yet.
          </p>
          <p className={'text-center text-sm text-ebony font-semibold'}>
            Would you like the new version to go live?
          </p>
        </div>
        <DialogFooter className="max-md:flex-row max-md:gap-2.5 !justify-center flex w-full pt-1">
          <ToolTip
            side={'top'}
            trigger={
              <Button
                onClick={onSaveForLater}
                variant="outline"
                className="transparent black min-w-28 w-[150px]"
              >
                Save for Later
              </Button>
            }
            content={
              <span className={'text-ebony_opacity_50 text-xs font-medium'}>
                Keep the new version as
                <br /> draft without deploying.
              </span>
            }
          />
          <DialogClose asChild>
            <ToolTip
              side={'top'}
              trigger={
                <Button onClick={onDeploy} variant={'green'} className={'w-[150px] font-semibold'}>
                  Deploy Now
                </Button>
              }
              content={
                <span className={'text-ebony_opacity_50 text-xs font-medium'}>
                  Publish the new version
                  <br /> and make it live.
                </span>
              }
            />
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
